export default __webpack_public_path__ + "static/media/OFB.9c552d63.jpg";